import * as React from 'react'
import Menu from '@mui/material/Menu'
import { Drawer, IconButton, Typography } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'

import { Box } from '@mui/system'
import { useState } from 'react'
import useStyles from './useStyles'
import StepperSeeMore from '../../../../../components/Modals/Subscriber/Products/RightModals/SeeMore'

export default function ModalMenuItem ({ item, suscriber, setLoading }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const [stateSeeMore, setstateSeeMore] = useState(false)

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const listSeeMore = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 800 }}
      role="presentation"
    >
      <StepperSeeMore
        setstateSeeMore={setstateSeeMore}
        item={item}
        suscriber={suscriber}
        setLoading={setLoading}
      />
    </Box>
  )

  return (
    <>
      <MoreVertIcon
        sx={{
          color: '#026873',
          '&:hover': {
            color: '#00FFAC'
          }
        }}
        onClick={handleClickMenu}
      />

      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList
          item={item}
          onClose={handleClose}
          setstateSeeMore={setstateSeeMore}
        />
      </Menu>

      <Drawer anchor={'right'} open={stateSeeMore}>
        {listSeeMore('right')}
      </Drawer>
    </>
  )
}

function FiltersList ({ item, onClose, setstateSeeMore }) {
  const classes = useStyles()
  return (
    <Box className={classes.boxStyle}>
      <IconButton
        onClick={() => {
          setstateSeeMore(true)
          onClose()
        }}
      >
        <Box className={classes.boxTypography}>
          <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
          <Typography className={classes.typographyStyle}>
            Ver detalles
          </Typography>
        </Box>
      </IconButton>
    </Box>
  )
}
